import * as React from 'react';

const SortUpIcon = ({ color }) => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M9 11.9333C9 12.5224 8.55228 13 8 13C7.44772 13 7 12.5224 7 11.9333V6.13193L5.43756 7.74531C5.1087 8.0849 4.57551 8.0849 4.24665 7.74531C3.91778 7.40572 3.91778 6.85515 4.24665 6.51556L7.40454 3.25469C7.7334 2.9151 8.2666 2.9151 8.59546 3.25469L11.7534 6.51556C12.0822 6.85515 12.0822 7.40572 11.7534 7.74531C11.4245 8.0849 10.8913 8.0849 10.5624 7.74531L9 6.13193V11.9333Z"
      fill={color}
    />
  </svg>
);
export default SortUpIcon;
